export const CAT_ID = {
  RANDOM_PRODUCT: 1,
  ONLINE_CONSULTION: 2,
  COURSE: 3,
  VIDEO: 4,
  EXCLUSIVE_EBOOK: 5,
  TICKET_ACCOUNT: 7,
  PHOTO: 8
}